import React from 'react';
import { forEach, get } from 'lodash';
import connect from 'react-redux/es/connect/connect';
import { CheckboxTree, TreeRow } from './CheckboxTree';
import { actions as channelActions } from '../../../redux/channelActions';
import { Form, formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators, compose } from 'redux';

class SchemeTreeForm extends React.PureComponent {
  componentWillMount() {
    const { channelSchemes, dispatch, change } = this.props;

    forEach(channelSchemes, (scheme) => {
      const insurerId = get(scheme, 'relationships.insurer.data.id');

      if (insurerId) {
        dispatch(change(`insurers[${insurerId}]`, true));
      }
    });
  }

  render() {
    const { allInsurers, handleSubmit, dirty } = this.props;
    return (
      <Form onSubmit={handleSubmit(this._handleSubmit)}>
        <CheckboxTree showSaveButton={dirty}>
          {allInsurers.map((insurer) => {
            return (
              <TreeRow
                key={insurer.attributes.key}
                label={insurer.attributes.name}
                fieldName={`insurers[${insurer.id}]`}
              />
            );
          })}
        </CheckboxTree>
      </Form>
    );
  }

  _handleSubmit = (formValues) => {
    const { allSchemes, channelId, channelActions } = this.props;

    const selectedInsurers = [];
    forEach(formValues.insurers, (selected, insurer) => {
      if (selected === true) {
        selectedInsurers.push(insurer);
      }
    });

    const schemeArray = allSchemes.filter((scheme) => {
      return selectedInsurers.indexOf(scheme.relationships.insurer.data.id) !== -1;
    });

    const value = {
      data: {
        relationships: {
          schemes: {
            data: schemeArray,
          },
        },
      },
    };

    channelActions.updateChannel(channelId, value);
  };
}

const FORM_NAME = 'SchemeThreeForm';

const selector = formValueSelector(FORM_NAME);
export default compose(
  connect(
    (state) => ({
      formValues: selector(state, 'insurers'),
    }),
    (dispatch) => ({
      channelActions: bindActionCreators(channelActions, dispatch),
    }),
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(SchemeTreeForm);
